










import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class PaymentInfoModal extends Vue {
  @Prop({}) title!: string;

  show() {
    (this.$refs.payment as any).show();
  }

  hide() {
    (this.$refs.payment as any).hide();
  }

  handleSave() {
    this.$emit("handleSave");
  }
}
